import styled from "styled-components";
import KayitliAdreslerimeEkleCheckbox from "../sections/shared/inputs/KayitliAdreslerimeEkleCheckbox";
import AddRoute from "../sections/shared/others/AddRoute";
import YuklemeAdresInput from "../sections/yukleme/inputs/YuklemeAdresInput";
import YuklemeDateInput from "../sections/yukleme/inputs/YuklemeDateInput";
import YuklemeAllTimeCheckbox from "../sections/yukleme/inputs/YuklemeAllTimeCheckbox";
import YuklemeTimeRangeInput from "../sections/yukleme/inputs/YuklemeTimeRangeInput";
import KayitliAdreslerimYuklemeInput from "../sections/yukleme/inputs/KayitliAdreslerimYuklemeInput";
import YuklemeCityTownInput from "../sections/yukleme/inputs/YuklemeCityTownInput";
import YuklemeAdresTarifiInput from "../sections/yukleme/inputs/YuklemeAdresTarifiInput";
import YuklemeBicimiInput from "../sections/yukleme/inputs/YuklemeBicimiInput";
import YuklemeEnGecDateInput from "../sections/yukleme/inputs/YuklemeEnGecDateInput";
import RouteLine from "../sections/shared/others/RouteLine";
import BtnOutline from "../../shared/button/BtnOutline";

import { MdKeyboardArrowRight } from "react-icons/md";
import { scrollToTop } from "../../../helper/scrollToTop";
import { useDispatch } from "react-redux";
import {
  setItemName,
  setPermissionData,
  setRouteItem,
  setRoutePermissionData,
  setSelectedRouteItem,
  setSelectedRouteItemId,
  setSelectedRouteItemType,
} from "../../../features/addLoad/addLoadSlice";
import { showModal, showNestedModal } from "../../../features/modal/modalSlice";
import KayitliAdreslerimeEkleNameInput from "../sections/shared/inputs/KayitliAdreslerimeEkleNameInput";
import { useSelector } from "react-redux";

const Container = styled.div`
  width: auto;

  color: ${({ theme }) => theme.mainTextColor};

  .route-list {
    display: flex;
    flex-direction: column;
    width: auto;

    .route-item {
      width: auto;
      display: flex;

      .form-side {
        display: flex;
        flex-direction: column;
        margin-left: 6px;

        .item-top {
          padding-left: 3px;
          border-bottom: 1px solid ${({ theme }) => theme.mainTextColor};
          padding-bottom: 2px;
          display: flex;
          justify-content: space-between;

          h4 {
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-xl);
          }

          .delete-btn {
            padding: 4px 14px;
            border-radius: 5px;
            background-color: ${({ theme }) => theme.secondaryBgColor};
            font-size: var(--font-size-sm);
            font-size: 12px;
            font-weight: var(--font-weight-lg);
            cursor: pointer;

            &:hover {
              background-color: ${({ theme }) => theme.mainTextColor};
              color: ${({ theme }) => theme.mainBgColor};
            }
          }
        }

        .input-list {
          display: flex;
          flex-direction: column;
          padding-left: 20px;
          padding-top: 20px;
          gap: 20px;
          margin-bottom: 40px;

          .grp {
            display: flex;
            align-items: center;
            gap: 10px;

            .redirect-span{
              font-size: var(--font-size-sm);
              font-size: 12px;
              font-weight: var(--font-weight-lg);
              display: flex;
              align-items: center;
              gap: 5px;
              cursor: pointer;
            }
          }

          .grp-top-aligned {
            display: flex;
            align-items: flex-start;
            gap: 10px;

            .google-adres-container{
              width: auto;
              max-width: 400px;
              height: 54px;
              background-color: ${({ theme }) => theme.secondaryBgColor};
              border: 1px solid ${({ theme }) => theme.mainBorderColor};
              font-size: 12px;
              font-weight: var(--font-weight-md);
              border-radius: 5px;
              padding: 5px 10px;
              display: flex;
              flex-direction: column;
              gap: 5px;

              .google-adres-top{
                font-weight: var(--font-weight-lg);
                text-decoration: underline;
              }

              .google-adres{
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

  .bottom-btn-container {
    width: 100%;
    padding: 50px;
    display: flex;
    justify-content: space-between;

    .icon {
      fill: var(--color-main);
      font-size: 1.6rem;
    }

    span {
      color: ${({ theme }) => theme.mainTextColor};
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-xl);
    }
  }
  .margin{
    margin-bottom: 30px;
  }

  @media (max-width: 1700px){
    .grp-top-aligned{
      flex-direction: column !important;
    }
  }
`;

const YuklemeSection = ({ setPhase, yuklemeDataList, isKayitLoad }) => {
  
  const dispatch = useDispatch();

  const {currentDate} = useSelector(state => state.addLoad)
  const {theme} = useSelector(state => state.layout)
  
  return (
    <Container>
      <div className="route-list">
        {yuklemeDataList?.map((item, i) => (
          <div key={i} className="route-item">
            <RouteLine type={i === 0 ? "start" : "mid"} />
            <div className="form-side">
              <div className="item-top">
                <h4 className="h4">
                  {yuklemeDataList?.length > 1 && i + 1 + "."} Yükleme{" "}
                  {item.locationData?.location &&
                    `(${item?.locationData?.location})`}
                </h4>
                {yuklemeDataList?.length > 1 && (
                  <button className="delete-btn" onClick={() => {dispatch(showNestedModal("deleteLoadRoutePermission")); dispatch(setRoutePermissionData(item)); }}>
                    Sil
                  </button>
                )}
              </div>
              <div className="input-list">
                <KayitliAdreslerimYuklemeInput itemForKayitliAdres={item} name={`kayitliAdreslerimYuklemeInput${item.id}`}/>
                <div className="grp">
                  <YuklemeCityTownInput data={item} name={"yuklemeCityTown" + i} isRequired={true} />
                  {/* <span onClick={() => {
                    dispatch(showNestedModal("singleRouteMap"));
                    dispatch(setSelectedRouteItem(item))
                    dispatch(setSelectedRouteItemType(true))
                    }}
                    className="redirect-span"
                    >
                      <svg
                      className="redirect"
                      width="17"
                      height="19"
                      viewBox="0 0 17 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 11.5C0 7.36 3.36 4 7.5 4H10V0L17 6L10 12V8H7.5C5.57 8 4 9.57 4 11.5V19H0V11.5Z"
                        fill={theme === "dark" ? "#f4f4f4" : "#3D3D3B"}
                      />
                    </svg>
                    Haritadan Konum Seç
                  </span> */}
                </div>
                <div className="grp-top-aligned">
                  <YuklemeAdresInput data={item} name={"yuklemeAdres" + item.id} isRequired={false} />
                  {
                    item.locationData.googleLocation &&
                    <div className="google-adres-container">
                      <div className="google-adres-top">Seçilen Adres</div>
                      <div className="google-adres">{item.locationData.googleLocation}</div>
                    </div>
                  }
                </div>
                <div className="grp-top-aligned">
                  <YuklemeAdresTarifiInput data={item} name={"yuklemeAdresTarif" + item.id} isRequired={false} />
                  <YuklemeBicimiInput data={item} name={"yuklemeBicimi" + item.id} isRequired={false} />
                </div>
                {!isKayitLoad &&
                  <>
                    <div className={`grp ${currentDate===false && "margin"}`}>
                      <YuklemeDateInput data={item} name={"yuklemeDate" + item.id} isRequired={true} />
                      <YuklemeEnGecDateInput data={item} name={"yuklemeDateEngec" + item.id} isRequired={false} />
                      
                    </div>
                    <div className="grp">
                      <YuklemeTimeRangeInput data={item} name={"yuklemeSaat" + item.id} isRequired={false}/>
                      <YuklemeAllTimeCheckbox data={item} name={"yuklemeSaatAllTime" + item.id} isRequired={false}/>
                    </div>
                  </>
                }
                {!isKayitLoad &&
                  <>
                    <div className="grp">
                      <KayitliAdreslerimeEkleCheckbox data={item} name={"addressKayit" + item.id}/>
                    </div>
                    {
                      item.adresKaydedilsinMi &&
                      <div className="grp">
                        <KayitliAdreslerimeEkleNameInput data={item} name={"addressKayitName" + item.id} isRequired={item?.adresKaydedilsinMi}/>
                      </div>
                    }
                  </>
                }
                
              </div>
            </div>
          </div>
        ))}
        <AddRoute order={yuklemeDataList?.length + 1} type="yukleme" />
      </div>

      <div className="bottom-btn-container">
        {/* //! placeholder */}
        <div />
        <BtnOutline height={"40px"} width={"120px"} radius={"10px"} handleClick={() => { setPhase({ id: 2, name: "Boşaltma" }); scrollToTop(); }}>
          <span>Boşaltma</span>
          <MdKeyboardArrowRight className="icon" />
        </BtnOutline>
      </div>
    </Container>
  );
};

export default YuklemeSection;
